import {React, Component} from 'react'


import Header from '../../components/Header/Header'
import FaqsGif from '../../assets/404.gif'
import './Faqs.css';


class Faqs extends Component {
  constructor(props){
    super(props)
    this.state = {
        faqs: [
            {
                question: "What are Pixelglyphs?",
                answer: "balh"
            },
            {
                question: "Why should I help?",
                answer: "balh"
            },
            {
                question: "How can I contribute?",
                answer: "The easiest way to contribute is to classfiy the Pixelglyphs! If you want to contribute on the dev side, please reach out!"
            },
            {
                question: "What are Pixelglyphs?",
                answer: "balh"
            },
            {
                question: "What are Pixelglyphs?",
                answer: "balh"
            },
            {
                question: "What are Pixelglyphs?",
                answer: "balh"
            },
            {
                question: "What are Pixelglyphs?",
                answer: "balh"
            },
            {
                question: "What are Pixelglyphs?",
                answer: "balh"
            },
            {
                question: "What are Pixelglyphs?",
                answer: "balh"
            },
        ]
    }
  }


  

  render(){
    return (
      <div className="Faqs">
          <Header/>
          <div style={{fontSize:"65px", margin:"20px 0px 40px 0px", fontWeight:"900", letterSpacing:"3px"}}>FAQs</div>

        <div className="faqs">
            {this.state.faqs.map(element=>{
                return(
                    <div style={{margin:"20px"}}>
                        <div className="question">
                            {element.question}
                        </div>
                        <div className="answer">
                            {element.answer}
                        </div>
                    </div>
                )
            })}
        </div>  
        
      </div>
                              
    
    );
  
  }
}

export default Faqs;
